import React, { useEffect, useState, useReducer, useContext, useRef } from "react";
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { CardNotasFiscais } from "../../../components/CardNotasFiscais";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { IconRefresh } from "../../../svg";
import { ToggleSwitch } from "../../../components/ToggleSwitch";
import { DynamicInput } from "../../../components/DynamicInput";
import { DynamicSelect } from "../../../components/DynamicSelect";
import { Footer } from "../../../components/Footer";
import { StldRow } from "../../../styled-components/StldRow.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { useForm } from 'react-hook-form';
import { PaginationCustom } from "../../../components/PaginationCustom";
import api from '../../../services/api';
import { MobileContext } from "../../../contexts/MobileContext";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { getStatusList } from '../../../services/status';
import { getClients } from '../../../services/clientes';
import { getEmpresas } from '../../../services/empresas';
import { getDisciplinas } from '../../../services/disciplinas';
import { ModalNotafiscalHistorico } from "../../../components/ModalNotafiscalHistorico";
import { Multiselect } from 'multiselect-react-dropdown';
import * as moment from 'moment'
import DatePicker from 'react-datepicker';
import IntlCurrencyInput from "react-intl-currency-input";
import { StldInput } from '../../../styled-components/StyledInput.style';
import XLSX from 'sheetjs-style';

const advanceSearch = { name: 'advanceSeach', label: 'Pesquisa Avançada', id: 'advanceSeachAP' };
const advanceFaturados = { name: 'advanceFaturados', label: 'Apenas Faturados', id: 'advanceFaturadosAP', status: true };

const getLista = async (formValues = null, currentPage = 0, pageSize) => {
    let list = null;

    let params = `Start=${currentPage}&Length=${pageSize}`;

    if (formValues.search != null && formValues.search != 0) {
        params += `&Search=${formValues.search}`;
    }

    if (formValues.numeroNF != null && formValues.numeroNF != 0) {
        params += `&NumeroNF=${formValues.numeroNF}`;
    }

    if (formValues.data?.Segurado?.length > 0) {
        params += `&Segurado=${formValues.data.Segurado}`;
    }

    if (formValues.data?.Sigla?.length > 0) {
        params += `&Sigla=${formValues.data.Sigla}`;
    }

    if (formValues.data?.NumeroTimesheet?.length > 0) {
        params += `&NumeroTimesheet=${formValues.data.NumeroTimesheet}`;
    }

    if (formValues.data?.NumeroNF?.length > 0) {
        params += `&NumeroNF=${formValues.data.NumeroNF}`;
    }

    if (formValues.data?.NumeroOS?.length > 0) {
        params += `&NumeroOS=${formValues.data.NumeroOS}`;
    }

    if (formValues.idCliente > 0) {
        params += `&IdCliente=${formValues.idCliente}`;
    }

    if (formValues.idStatus > 0) {
        params += `&Status=${formValues.idStatus}`;
    }

    if (formValues.startDate) {
        var inicio = moment(formValues.startDate).format('YYYY-MM-DD')
        inicio += " 00:00"
        params += `&PeriodoInicial=${inicio}`;
    }

    if (formValues.endDate) {
        var final = moment(formValues.endDate).format('YYYY-MM-DD')
        final += " 23:59:59"
        params += `&PeriodoFinal=${final}`;
    }

    if (formValues.idEmpresa > 0) {
        params += `&IdEmpresa=${formValues.idEmpresa}`;
    }

    if (formValues.idDisciplinas?.length > 0) {
        formValues.idDisciplinas.forEach(disciplina => {
            params += `&Disciplinas=${disciplina}`;
        });
    }

    if (formValues.valorInicial > 0) {
        params += `&ValorInicial=${formValues.valorInicial}`;
    }

    if (formValues.valorFinal > 0) {
        params += `&ValorFinal=${formValues.valorFinal}`;
    }

    try {
        const response = await api.get(`NotaFiscal/list?${params}`);
        list = response.data;
        return list;
    } catch (err) {
        return list;
    }
}

export const NotasFiscais = () => {
    const [showAdvanceSearch, setAdvanceSearch] = useState(false);
    const [apenasFaturados, setApenasFaturados] = useState(null);
    const [ListaData, setListaData] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const { register, handleSubmit, reset } = useForm();
    const [clientList, setClientList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [empresaList, setEmpresaList] = useState([]);
    const [disciplinaList, setDisciplinaList] = useState([]);
    var [idDisciplinas, setDisciplinasId] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    var [loadingData, setLoadingData] = useState(false);
    var [idStatus, setStatusId] = useState(1);
    var [idEmpresa, setEmpresaId] = useState([]);
    var [selectedEmpresa, setselectedEmpresa] = useState(null);
    var [cliente, setCliente] = useState(null);
    var [idCliente, setIdCliente] = useState(null);
    var [status, setStatus] = useState("Faturado");
    var [searchReadOnly, setSearchReadOnly] = useState(false);

    var [valorMinimo, setValorMinimo] = useState(null);
    var [valorMaximo, setValorMaximo] = useState(null);

    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;

    var [searchInput, setSearchInput] = useState(null);
    var [searchNFInput, setSearchNFInput] = useState(null);
    const [selectedNotaFiscal, setSelectedNotaFiscal] = useState(null);

    const currencyConfig = {
        locale: "pt-BR",
        formats: {
            number: {
                BRL: {
                    style: "currency",
                    currency: "BRL",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                },
            },
        },
    };

    const formSubmit = async (data) => {
        loadTable(data, 0, 10);
    }

    const loadTable = async (data, currentPage, pageSize) => {
        let formValues = {
            data: data,
            search: 0,
            idCliente: idCliente,
            idStatus: idStatus,
            idEmpresa: idEmpresa,
            startDate: startDate,
            endDate: endDate,
            valorInicial: valorMinimo != null ? valorMinimo : null,
            valorFinal: valorMaximo != null ? valorMaximo : null,
            idDisciplinas: idDisciplinas
        };
        setListaData(null);
        setLoadingData(true);
        const lista = await getLista(formValues, currentPage, pageSize);

        setListaData(lista);
        if (lista != null && lista?.data?.itens?.length > 0) {
            pageSize = lista.data.page.recordsPaging;
            setPageSize(pageSize);
        }
        setLoadingData(false);
    }

    const getStatusToggle = (status) => {
        setAdvanceSearch(status);
        setSearchReadOnly(status);
        searchReadOnly = status;
    };

    const getApenasFaturadosToggle = async (status) => {
        setApenasFaturados(status);

        if (status) {
            getStatus("", 1)
        }
        else {
            getStatus("", "clear")
        }

        setTimeout(() => {
            submitButtonRef.current.click()
        }, 500);
    };

    const getSearch = async (currentValue, value) => {
        let data = {}
        let formValues = {
            data: data,
            search: (currentValue?.length >= 3) ? currentValue : null,
            numeroNF: (searchNFInput?.length >= 1) ? searchNFInput : null,
            idCliente: null,
            idEmpresa: idEmpresa,
            idStatus: null,
            startDate: null,
            endDate: null,
            idDisciplinas: null,
            valorInicial: null,
            ValorFinal: null
        };

        setPageSize(pageSize);
        const listaData = await getLista(formValues, currentPage, pageSize);
        setListaData(listaData);

        setSearchInput((currentValue?.length >= 3) ? currentValue : null)
    };

    const getSearchByNF = async (currentValue, value) => {
        let data = {}

        let formValues = {
            data: data,
            search: (searchInput?.length >= 3) ? searchInput : null,
            numeroNF: (currentValue?.length >= 1) ? currentValue : null,
            idCliente: null,
            idEmpresa: idEmpresa,
            idStatus: null,
            startDate: null,
            endDate: null,
            idDisciplinas: null,
            valorInicial: null,
            ValorFinal: null
        };

        setPageSize(pageSize);
        const listaData = await getLista(formValues, currentPage, pageSize);
        setListaData(listaData);

        setSearchNFInput((currentValue?.length >= 1) ? currentValue : null)
    };

    const refreshData = async () => {
        let data = {
            IdentificaoSolicitacao: null,
            Segurado: null,
            Contato: null,
            Endereco: null
        }

        let formValues = {
            data: data,
            search: (searchInput?.length >= 3) ? searchInput : '',
            idCliente: idCliente,
            idStatus: idStatus,
            startDate: startDate,
            endDate: endDate,
            valorInicial: null,
            ValorFinal: null
        };

        setPageSize(pageSize);
        setListaData(null);
        setLoadingData(true);

        try {
            const listaData = await getLista(formValues, currentPage, pageSize);
            setListaData(listaData);
            setLoadingData(false)
        } catch (error) {
            setLoadingData(false);
        }
    }

    const getCliente = (currentValue, value) => {

        if (value === "clear" || value === null) {
            setCliente(null);
            setIdCliente(null);
            return;
        }

        var clienteResult = clientList.filter(function (o) {
            return o.idCliente == value;
        });

        cliente = clienteResult[0].cliente;
        idCliente = clienteResult[0].idCliente;
        setCliente(cliente);
        setIdCliente(idCliente);
    };

    const getStatus = (currentValue, value) => {
        if (value === "clear" || value === null) {
            setStatus(null);
            setStatusId(null);
            return;
        }

        var statusResult = statusList.filter(function (o) {
            return o.key == value;
        });

        status = statusResult[0].value;
        idStatus = statusResult[0].key;
        setStatus(status);
        setStatusId(idStatus);
    };

    const getEmpresa = (currentValue, value) => {
        if (value === "clear" || value === null) {
            setselectedEmpresa(null);
            setEmpresaId(null);
            return;
        }

        var statusResult = empresaList.filter(function (o) {
            return o.idEmpresa == value;
        });

        status = statusResult[0].description;
        idStatus = statusResult[0].idEmpresa;
        setselectedEmpresa(status);
        setEmpresaId(idStatus);
    };

    const getCardId = (id) => {
        let cardId = document.getElementById(id);

        if (cardId.getAttribute('class', 'card-menu-hide') === 'card-menu-hide') {
            cardId.removeAttribute('class', 'card-menu-hide');
            cardId.setAttribute('class', 'card-menu-show');
        }
        else {
            cardId.removeAttribute('class', 'card-menu-show');
            cardId.setAttribute('class', 'card-menu-hide');
        }
    };

    const onGetDisciplina = (currentValue, value) => {
        let disciplinasList = [];
        currentValue.map(a => { disciplinasList.push(a.idDisciplina) });
        setDisciplinasId(disciplinasList);
    };

    const onRemoveDisciplina = (currentValue, value) => {
        onGetDisciplina(currentValue)
    }

    useEffect(() => {
        const asyncFn = async () => {
            const clients = await getClients();
            if (!!clients) {
                setClientList(clients);
            }

            const statusList = await getStatusList(49);
            if (!!statusList) {
                setStatusList(statusList)
            }

            const empresaList = await getEmpresas();
            if (!!empresaList) {
                setEmpresaList(empresaList)
            }

            const disciplinas = await getDisciplinas();
            if (!!disciplinas) {
                setDisciplinaList(disciplinas);
            }
        }
        loadTable(null, 0, 10);
        asyncFn();
    }, [null, 0, 10]);

    const submitButtonRef = useRef(null)

    const [startDate, setStartDate] = useState(null);
    const handleStartDateChange = (date) => {
        setStartDate(date);
    }

    const [endDate, setEndtDate] = useState(null);
    const handleEndDateChange = (date) => {
        setEndtDate(date);
    }

    const openModalHistorico = (item) => {
        setSelectedNotaFiscal(item);
        setmodalOrdenServicoEdicao(true);
    };

    const [modalOrdenServicoEdicao, setmodalOrdenServicoEdicao] = useState(false);
    const closemodalOrdenServicoEdicao = () => {
        setmodalOrdenServicoEdicao(false);
        setSelectedNotaFiscal(null)
    }

    const autofitColumns = (json, worksheet) => {
        let objectMaxLength = [];

        json.map(jsonData => {
            Object.entries(jsonData)
                .map(([, v], idx) => {
                    let columnValue = v
                    objectMaxLength[idx] = objectMaxLength[idx] >= columnValue.length ? objectMaxLength[idx] : columnValue.length
                })
        })

        const wscols = objectMaxLength.map((w) => ({ width: w < 20 ? 20 : w }))
        worksheet["!cols"] = wscols;
    }

    const exportExcel = () => {
        const xlsxData = []
        ListaData?.data?.itens?.map(item => {
            item.timesheets.map(timesheet => {
                xlsxData.push({
                    "Status": item.notaFiscal.status,
                    Laudo: timesheet.pericia.sigla,
                    TS: timesheet.timeSheetSigla,
                    Disciplina: timesheet.disciplina.nome,
                    "Nº NF": item.notaFiscal.numero,
                    "Valor NF": item.notaFiscal.valorTotal,
                    "Valor dos Impostos": item.notaFiscal.status == 'Recebido' ? item.notaFiscal.valorImpostos : "R$ 0,00",
                    "Valor Liq. Recebido": item.notaFiscal.valorTotalRecebido,
                    // "Valor Total": timesheet.valorTimesheet,
                    "Faturado em": item.notaFiscal.dataCadastro.split(" ")[0],
                    "Recebido em": item.notaFiscal.dataRecebimento.split(" ")[0],
                    "Reemitido em": item.notaFiscal.dataReemissao.split(" ")[0],
                    "Cancelado em": item.notaFiscal.dataCancelamento.split(" ")[0],
                    Cliente: item.notaFiscal.cliente.nome,
                    "Analista": timesheet.pericia.analista,
                    Segurado: timesheet.segurado.nome,
                    "Total Horas": timesheet.horasTimeSheet,
                    "Líder": timesheet.pericia.liderPericia,
                })
            })
        })

        const worksheet = XLSX.utils.json_to_sheet(xlsxData);

        autofitColumns(xlsxData, worksheet);
        const fill = {
            font: {
                bold: true,
                color: { rgb: "FFFFFF" }
            },
            fill: {
                type: 'pattern',
                patternType: 'solid',
                fgColor: { rgb: "000080" }
            }
        };
        worksheet["A1"].s = fill;
        worksheet["B1"].s = fill;
        worksheet["C1"].s = fill;
        worksheet["D1"].s = fill;
        worksheet["E1"].s = fill;
        worksheet["F1"].s = fill;
        worksheet["G1"].s = fill;
        worksheet["H1"].s = fill;
        worksheet["I1"].s = fill;
        worksheet["J1"].s = fill;
        worksheet["K1"].s = fill;
        worksheet["L1"].s = fill;
        worksheet["M1"].s = fill;
        worksheet["N1"].s = fill;
        worksheet["O1"].s = fill;
        worksheet["P1"].s = fill;
        worksheet["Q1"].s = fill;
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ExportDB");
        XLSX.writeFile(workbook, "NotasFiscais.xlsx");
    }

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header m-0">Notas Fiscais</h5>
                            <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span>
                        </div>
                        {/* <input className='default-button-red' value='Adicionar' type="button" onClick={openModal} /> */}
                    </div>
                    <div className="card">
                        <div className="row">
                            <div className="col-sm-12 col-md-3 col-lg-3 col-xxl-3 my-1-mobile">
                                <DynamicInput
                                    placeholder={''}
                                    componentReadOnly={searchReadOnly}
                                    label={'Nº Nota Fiscal'}
                                    name={'NumeroNF'}
                                    paramMethod={getSearchByNF} />
                            </div>
                            <div className="col-sm-12 col-md-3 col-lg-3 col-xxl-3 my-1-mobile">
                                <DynamicInput
                                    placeholder={''}
                                    componentReadOnly={searchReadOnly}
                                    label={'Pesquisar'}
                                    name={'Search'}
                                    paramMethod={getSearch} />
                            </div>
                            <div className="d-flex flex-column justify-content-center justify-content-center col-sm-12 col-md-3 col-lg-2 col-xxl-2">
                                <ToggleSwitch config={advanceSearch} setStatus={(status) => getStatusToggle(status)} />
                            </div>
                            <div className="d-flex flex-column justify-content-center justify-content-center col-sm-12 col-md-3 col-lg-2 col-xxl-2">
                                <ToggleSwitch config={advanceFaturados} setStatus={(status) => getApenasFaturadosToggle(status)} />
                            </div>
                            <div className="d-flex flex-column justify-content-center justify-content-center col-sm-12 col-md-3 col-lg-2 col-xxl-2">
                                <input type="button" className='default-button-red ml-3' value='Exportar' onClick={exportExcel} />
                            </div>
                        </div>
                        <StyledForm onSubmit={handleSubmit(formSubmit)}>
                            <div className={!!showAdvanceSearch ? `form-wrapper filter-container mt-3` : `form-wrapper filter-container filter-hide`}>
                                <div className="position-relative form-group col-sm-12 col-sm-12 col-md-6 col-lg-6 p-2 header-select">
                                    <DynamicSelect
                                        placeholder={''}
                                        valuetext={selectedEmpresa}
                                        label={'Selecione a empresa'}
                                        name={'idEmpresa'}
                                        options={empresaList}
                                        keyValue={'idEmpresa'}
                                        keyLabel={'description'}
                                        paramMethod={getEmpresa}
                                        clearOption={true} />
                                </div>
                                {/* <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Nº Nota Fiscal'} name={'NumeroNF'} register={register} />
                                </div> */}
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Nº OS'} name={'NumeroOS'} register={register} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Nº Timesheet'} name={'NumeroTimesheet'} register={register} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2 header-select">
                                    <Multiselect
                                        className="searchWrapperCustom"
                                        placeholder={'Disciplinas'}
                                        showCheckbox="true"
                                        options={disciplinaList} // Options to display in the dropdown
                                        onSelect={onGetDisciplina} // Function will trigger on select event
                                        onRemove={onRemoveDisciplina} // Function will trigger on remove event
                                        displayValue="titulo" // Property name to display in the dropdown options
                                        showArrow={true}
                                    />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2 header-select">
                                    <DynamicSelect placeholder={''} valuetext={cliente} label={'Selecione o cliente'} name={'idCliente'} options={clientList} keyValue={'idCliente'} keyLabel={'cliente'} paramMethod={getCliente} clearOption={true} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Segurado'} name={'Segurado'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-sm-12 col-md-6 col-lg-6 p-2 header-select">
                                    <DynamicSelect placeholder={''} valuetext={status} label={'Status'} name={'idAtividade'} options={statusList} keyValue={'key'} keyLabel={'value'} paramMethod={getStatus} clearOption={true} />
                                </div>
                                <div className="position-relative col-sm-6 col-md-6 col-lg-6 p-2">
                                    <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 pl-0" style={{ float: 'left' }}>
                                        <DatePicker
                                            dateFormat="dd/MM/yyyy"
                                            locale="pt-BR"
                                            className="input-form"
                                            selected={startDate}
                                            onChange={handleStartDateChange}
                                            placeholderText={'Data de início'}
                                        />
                                    </div>
                                    <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 pr-0" style={{ float: 'left' }}>
                                        <DatePicker
                                            dateFormat="dd/MM/yyyy"
                                            locale="pt-BR"
                                            className="input-form"
                                            selected={endDate}
                                            onChange={handleEndDateChange}
                                            placeholderText={'Data fim'}
                                        />
                                    </div>
                                </div>
                                <div className="position-relative col-sm-6 col-md-6 col-lg-6 p-2">
                                    <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-0" style={{ float: 'left' }}>
                                        <StldInput>
                                            <label className="focused">Valor mínimo</label>
                                            <IntlCurrencyInput
                                                currency="BRL"
                                                config={currencyConfig}
                                                defaultValue={valorMinimo}
                                                onChange={(_event, value, _maskedValue) => {
                                                    setValorMinimo(value)
                                                }}
                                            />
                                        </StldInput>
                                    </div>

                                    <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 pr-0" style={{ float: 'left' }}>
                                        <StldInput>
                                            <label className="focused">Valor máximo</label>
                                            <IntlCurrencyInput
                                                currency="BRL"
                                                config={currencyConfig}
                                                defaultValue={valorMaximo}
                                                onChange={(_event, value, _maskedValue) => {
                                                    setValorMaximo(value)
                                                }}
                                            />
                                        </StldInput>
                                    </div>
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 p-2">
                                    <input type="submit" className='default-button-red' value='Pesquisar' ref={submitButtonRef} />
                                </div>
                            </div>
                        </StyledForm>
                        <br />

                        {loadingData ?
                            <StldRow>
                                <div className="text-center">
                                    <div className="align-items-center">
                                        <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                        <div><strong style={{ color: "#EE4B21" }}>{'Atualizando...'}</strong></div>
                                    </div>
                                </div>
                            </StldRow > :
                            ''}
                        <StldRow>
                            {
                                ListaData != null && ListaData?.data?.itens?.map((item, index) => {
                                    return (
                                        <StldColumn key={index} xs="12" sm="6" md="4" lg="4" xl="4">
                                            <CardNotasFiscais
                                                item={item}
                                                getCardId={getCardId}
                                                index={index}
                                                openModalHistorico={(item) => openModalHistorico(item)}
                                                loadOrdens={loadTable}
                                            />
                                        </StldColumn>
                                    )
                                })
                            }
                            {
                                ListaData?.data?.itens.length == 0 && <StldColumn xs="12" sm="12" md="12">
                                    <div className="alert alert-warning" role="alert">
                                        Atenção! Nenhum resultado encontrado!
                                    </div>
                                </StldColumn>
                            }
                        </StldRow>
                        {
                            (() => {
                                if (ListaData != null) {
                                    return (
                                        <PaginationCustom isMobile={isMobile}
                                            isDesktop={isDesktop}
                                            length={ListaData.data.page.length}
                                            recordsTotal={ListaData?.data?.page?.recordsTotal ?? 0}
                                            currentPage={currentPage}
                                            formData={loadTable}
                                            pageSize={pageSize ?? 10}
                                            setPageSize={setPageSize}
                                            setPage={(page) => setCurrentPage(page)} />
                                    )
                                }
                                return null
                            })()
                        }
                    </div>
                    <br />
                </StyledDefaultPage>
                <ModalNotafiscalHistorico
                    idTimesheet={selectedNotaFiscal?.timesheets[0]?.idTimesheet}
                    isOpen={modalOrdenServicoEdicao}
                    onRequestClose={closemodalOrdenServicoEdicao}
                    ariaHideApp={false}
                >
                </ModalNotafiscalHistorico>
            </main >

        </section >
    );
};

export const NotasFiscaisPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <NotasFiscais />

                </>
            )}
        </>
    );
};
